import { render } from "./MyRecords.vue?vue&type=template&id=1be95616"
import script from "./MyRecords.vue?vue&type=script&lang=js"
export * from "./MyRecords.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__